import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS, HttpEventType } from '@angular/common/http';
import { EMPTY, Observable, catchError, from, lastValueFrom, switchMap, tap } from 'rxjs';
import { IdbService } from '../idb.service';
import { LocalStorageService } from '../local-storage.service';
import { HttpClient } from '@angular/common/http';
import { ToastService } from 'src/app/core/toast/toast.service';

@Injectable()
export class ApiinterceptorInterceptor implements HttpInterceptor {

  networkStatus: boolean = true;
  nexts?: HttpHandler;
  constructor(
    private idb: IdbService,
    private localStorage: LocalStorageService,
    private http: HttpClient,
    private toast: ToastService
  ) {
    console.warn('HEHIHUHEUE')
    console.log(this.nexts)
    window.addEventListener("load", () => {
      this.networkStatus = navigator.onLine
      window.addEventListener("online", () => {
        this.networkStatus = true;
      });

      window.addEventListener("offline", () => {
        this.networkStatus = false;
      });
    });

  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {


    this.nexts = next;
    console.log("URL RICHIESTA: ");
    console.log(JSON.stringify(request.url));
    console.log("Header richiesta: ");
    console.log(JSON.stringify(request.headers));

    console.log("Body richiesta: ");
    console.log(JSON.stringify(request.body));


    if (!this.networkStatus) {
      this.idb.addItemRow('ApiCache', JSON.stringify(request), request.url);
      // this.idb.getItemRow('ApiCache',request.url).then((result:any)=>{
      //   if(result == null)
      //   {
      //     this.idb.addItemRow('ApiCache', JSON.stringify(request), request.url);
      //   }
      // })
      
      this.toast.GenerateToast({
        title: 'SEI OFFLINE',
        content: "riprova più tardi",
        severity: 'e-toast-warning'
      });

    }


    return next.handle(request).pipe(tap(
      data => {
        /*
                //####################### CODE FOR DISABLING BUTTONS DURING API #####################################################
                 let buttons = document.querySelectorAll('button');
                   // If request was sent
                   if ((data.type == 0))
                   {
                     console.log('CHANGING BUTTONS (MAYBE)')
        
                     this.toast.GenerateToast({
                       title: '',
                       content: 'CHANGING BUTTONS',
                       severity: 'e-toast-success'
                     });
                     buttons.forEach(button=>{
        
                      
                       if(button.getAttribute('disabled')=='true'){
                         
                           button.setAttribute('isalreadydisabled','true');
                         
                      
                        
                       }else{
                        button.setAttribute('disabled','true')
                       }
                        
                      
                      
                     })
                   }
                   else
                   {
                     console.log('CHANGING BUTTONS AGAIN (MAYBE)')
                     this.toast.GenerateToast({
                       title: '',
                       content: 'CHANGING BUTTONS AGAIN',
                       severity: 'e-toast-success'
                     });
                     buttons.forEach(button=>{
                     
                       if(button.getAttribute('isalreadydisabled')){
                         //button.setAttribute('disabled','true')
                        // button.removeAttribute('isalreadydisabled');
                       }else{
                         button.removeAttribute('disabled')
                       }
                       
                      
                     })
                    
                   }*/
      }
    ));
  }





  // customIntercept(request: HttpRequest<unknown>){

  //   return request.pipe(
  //       (()=>{
  //         return this.http.request(request.method, request.url, { body: request.body }).pipe(
  //           catchError((error) => {
  //             console.error(`Failed to sync request: ${request.url}`, error);
  //             return error;
  //           })
  //         );
  //       })

  //       )
  //     }
}


export const ApiinterceptorProvider = { provide: HTTP_INTERCEPTORS, useClass: ApiinterceptorInterceptor, multi: true }